import * as microsoftTeams from "@microsoft/teams-js";

/**
 * Attempts to read the token from Microsoft Teams. It is then used for token based single sign-on
 * @returns Promise<string|Error> - Returns authentication token from Microsoft Teams or Error
 */
export const getSSOToken = () => {
  return microsoftTeams.authentication
    .getAuthToken({ resources: [process.env.TAB_APP_URI] })
    .then((token) => {
      microsoftTeams.app.notifySuccess();
      return token;
    })
    .catch((message) => {
      microsoftTeams.app.notifyFailure({
        reason: microsoftTeams.app.FailedReason.AuthFailed,
        message,
      });
      throw message;
    });
};
